import styled from 'styled-components'
import Img from 'gatsby-image'

export const Avatar = styled(Img)`
    border-radius: 50%;
    margin: .25rem;
`;